export default "/fonts/Museo700-Regular-webfont.woff2?3996cfb94777931ad087935a5b89e1a8";